export const css = {
	root: '_230jaYQT',
	nav_drawer: 'ay-oL2YC',
	title: '_2HqiYmUp',
	' _key': 'afcpe-theme/afcpe/table-of-contents/drawer'
};

export default css;
